import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, CalendarDays, Sparkles } from "lucide-react";
import { useLang } from "@/i18n";

const ease = [0.16, 1, 0.3, 1];

export default function WorkshopBanner() {
  const navigate = useNavigate();
  const w = useLang().t.wkBanner;

  return (
    <section className="relative bg-ink px-5 py-14 sm:px-8 sm:py-16" data-testid="workshop-banner-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.7, ease }}
        className="relative mx-auto grid max-w-6xl grid-cols-1 overflow-hidden rounded-2xl border-2 border-accent/60 bg-gradient-to-r from-[#1C0413] via-[#26000F] to-card shadow-[0_0_60px_rgba(255,0,122,0.3)] md:grid-cols-[300px_1fr]"
      >
        <div className="relative hidden min-h-[420px] md:block">
          <img src="/images/jay-kim.jpg" alt={w.photoAlt} className="absolute inset-0 h-full w-full object-cover object-top" loading="lazy" />
          <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(90deg,transparent_55%,#16010C_100%)]" />
        </div>

        <div className="relative flex flex-col justify-center gap-4 p-7 sm:p-10">
          <div className="relative overflow-hidden rounded-xl bg-[radial-gradient(circle_at_50%_30%,rgba(255,0,122,0.25)_0%,#1C0413_75%)] md:hidden">
            <img src="/images/jay-kim.jpg" alt={w.photoAlt} className="h-auto w-full object-contain" loading="lazy" />
          </div>
          <p className="flex items-center gap-2 font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-accent">
            <Sparkles size={13} /> {w.badge}
          </p>
          <h2 className="font-display text-xl font-black uppercase leading-tight tracking-tight text-white sm:text-3xl">
            {w.title}
            <span className="mt-1 block text-[clamp(1.8rem,5vw,3rem)] text-accent drop-shadow-[0_0_25px_rgba(255,0,122,0.55)]">{w.feat}</span>
          </h2>
          <p className="max-w-xl text-sm leading-relaxed text-zinc-300">{w.desc}</p>

          <div className="flex flex-wrap items-center gap-2.5">
            <span className="flex items-center gap-2 rounded-full bg-accent px-4 py-2 font-display text-xs font-extrabold uppercase tracking-wide text-white shadow-[0_0_20px_rgba(255,0,122,0.5)]">
              <CalendarDays size={14} /> {w.date}
            </span>
            <span className="rounded-full border border-white/25 px-3.5 py-2 font-mono text-[11px] font-bold uppercase tracking-[0.15em] text-white">{w.single}</span>
            <span className="rounded-full border border-white/25 px-3.5 py-2 font-mono text-[11px] font-bold uppercase tracking-[0.15em] text-white">{w.full}</span>
          </div>

          <button
            type="button"
            data-testid="workshop-reserve-button"
            onClick={() => navigate("/workshop")}
            className="mt-2 inline-flex w-fit items-center gap-2 rounded-full bg-accent px-8 py-4 font-mono text-sm font-bold uppercase tracking-[0.15em] text-white shadow-[0_0_28px_rgba(255,0,122,0.45)] transition-all duration-300 hover:scale-[1.03] hover:bg-accent-hover"
          >
            {w.cta} <ArrowUpRight size={16} />
          </button>
        </div>
      </motion.div>
    </section>
  );
}